module.exports = __webpack_public_path__ + "static/media/metatrader4.ea7916e3.jpg";